module.exports = __webpack_public_path__ + "img/1 (11).9a6da8e7.jpg";